import { filter, take } from 'rxjs/operators';

import { ChangeDetectionStrategy, Component, ElementRef, OnInit } from '@angular/core';
import { IntersectionService } from '@core/services/intersection.service';
import { LoadScriptsService } from '@core/services/load-scripts/load-scripts.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'app-trust-pilot',
    templateUrl: './trust-pilot.component.html',
    styleUrls: ['./trust-pilot.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class TrustPilotComponent implements OnInit {
    private intersectionKey = 'intersectionTrustpilot';
    private widgetUrl = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';

    constructor(
        private intersectionService: IntersectionService,
        private element: ElementRef,
        private loadScriptsService: LoadScriptsService
    ) {}

    ngOnInit(): void {
        this.intersectionService
            .observe(this.intersectionKey, this.element.nativeElement, { rootMargin: '100px' })
            .pipe(
                untilDestroyed(this),
                filter(
                    (entry: IntersectionObserverEntry) =>
                        entry.target === this.element.nativeElement && entry.isIntersecting
                ),
                take(1)
            )
            .subscribe(() => this.loadScriptsService.loadScript(this.widgetUrl));
    }
}
